function initBMAXProgressBar(progressWrapper) {
  const container = document.getElementById(progressWrapper);
  if (!container || container.dataset.carouselInitialized === 'true') {
    return;
  }
  const carousel = container.querySelector('.overflow-x-scroll');
  if (!carousel) {
    return;
  }

  container.dataset.carouselInitialized = 'true';
  const leftButton = container.querySelector('button[data-carousel-dir="left"]');
  const rightButton = container.querySelector('button[data-carousel-dir="right"]');

  let isDragging = false;
  let didDrag = false;
  let startX = 0;
  let scrollLeft = 0;

  // Get the progress bar for this carousel
  const progressBar = container.querySelector('.js-progress-bar');
  const progressBarTrack = progressBar?.parentElement;

  // Function to update progress bar
  function updateProgress () {
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    let scrollPercentage = maxScroll > 0 ? (carousel.scrollLeft / maxScroll) * 100 : 0;
    const hasOverflow = maxScroll > 0;

    if (progressBarTrack) {
      progressBarTrack.classList.toggle('hidden', !hasOverflow);
    }

    carousel.style.cursor = hasOverflow ? 'grab' : '';

    // Update button visibility
    if (leftButton) {
      if (scrollPercentage == 0) {
        leftButton.classList.add('hidden');
        } else {
          leftButton.classList.remove('hidden');
        }
    }
    if (rightButton) {
      if (scrollPercentage >= 100 || maxScroll <= 0) {
        rightButton.classList.add('hidden');
      } else {
        rightButton.classList.remove('hidden');
      }
    }

    // Update progress bar width
    if (!hasOverflow) return;
    if (scrollPercentage < 25) scrollPercentage = 25;
    if (progressBar) progressBar.style.width = `${scrollPercentage}%`;
  };

  // Mouse events
  carousel.addEventListener('mousedown', (e) => {
    e.preventDefault();
    isDragging = true;
    didDrag = false;
    carousel.style.cursor = 'grabbing';
    carousel.style.userSelect = 'none';
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    didDrag = true;
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1; // Scroll speed multiplier
    carousel.scrollLeft = scrollLeft - walk;
    updateProgress();
  });

  container.addEventListener('click', (e) => {
    const button = e.target.closest('[data-carousel-dir]');
    if (!button) {
      if (e.target.tagName === 'A' && mousePosition !== e.clientX) {
        e.preventDefault();
      }
      return;
    }

    const scrollAmount = 300;
    if (button.getAttribute('data-carousel-dir') === 'left') {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else if (button.getAttribute('data-carousel-dir') === 'right') {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
    didDrag = false;
  });

  carousel.addEventListener('mouseup', () => {
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
  });

  carousel.addEventListener('mouseleave', () => {
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
  });

  // Update progress on scroll events
  carousel.addEventListener('scroll', updateProgress);

  // Set initial cursor style and progress
  updateProgress();

  window.addEventListener('resize', updateProgress);
}

// Event listeners for different scenarios

document.addEventListener('quick-rca-quick-view-opened', (event) => {
  const modal = event.detail;
  if (modal) {
    initBMAXProgressBar(modal.id);
  }
});

document.addEventListener('nosto:recommendations-loaded', (event) => {
  const container = document.getElementById(`js-${event.detail}`);
  if (container) {
    delete container.dataset.carouselInitialized;
  }
  initBMAXProgressBar(`js-${event.detail}`);
});

// Make function globally available
if (!window.initBMAXProgressBar) {
  window.initBMAXProgressBar = initBMAXProgressBar;
}
